export default {
  firstDayOfWeek: 1,
  dayNames: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
  dayNamesShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  monthNames: [ "Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь" ],
  monthNamesShort: [ "Янв", "Фев", "Март", "Апр", "Май", "ИЮнь","Июль", "Авг", "Сен", "Окт", "Ноябрь", "Дек" ],
  today: 'Сегодня',
  clear: 'Очистить',
  dateFormat: 'dd.mm.yy',
  weekHeader: 'Неделя'
}